import React, { useEffect, useState } from 'react';
import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';
import theme from '../theme';

function LoadingScreen({ loadingMessage }) {
  const resTheme = useTheme();
  const isMobile = useMediaQuery(resTheme.breakpoints.down("md"));
  const [progress, setProgress] = useState(0);
  const [waveOffset, setWaveOffset] = useState(0);

  useEffect(() => {
    let t = 0;
    let frameId;

    const animate = () => {
      setProgress((Math.sin(t - Math.PI / 2) * 0.5 + 0.5) * 90);
      setWaveOffset((prev) => prev + 1);
      t += 0.025;
      frameId = requestAnimationFrame(animate);
    };

    frameId = requestAnimationFrame(animate);

    return () => cancelAnimationFrame(frameId);
  }, []);

  // Parameters for wave
  const waveHeight = 15; // vertical amplitude
  const waveWidth = 75; // wavelength
  const viewHeight = 154;
  const viewWidth = 141;
  const fillHeight = (viewHeight * progress) / 100;

  // Build wave path dynamically
  const buildWavePath = () => {
    let path = `M 0 ${viewHeight - fillHeight}`;
    for (let x = 0; x <= viewWidth; x++) {
      const y =
        viewHeight -
        fillHeight +
        Math.sin((x + waveOffset) / waveWidth * 2 * Math.PI) * waveHeight;
      path += ` L ${x} ${y}`;
    }
    path += ` L ${viewWidth} ${viewHeight} L 0 ${viewHeight} Z`;
    return path;
  };

  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        bgcolor: "rgba(0,0,0,0.5)",
        backdropFilter: "blur(8px)", // Blur effect

        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        gap: 1.5,

        zIndex: isMobile ? 999 : 99999,
      }}
    >
      <svg
        width="64"
        height="64"
        viewBox={`0 0 ${viewWidth} ${viewHeight}`}
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <clipPath id="uClip">
            <path d="M0.521484 0.582031C8.77554 1.89949 16.6014 6.73563 23.082 12.3408C29.6416 18.0143 34.7745 24.433 37.5215 28.6494V96.5C37.5215 108.362 51.3492 124.524 76.5811 121.496C96.8835 119.06 102.679 103.869 103.021 96.5234L103.022 96.5117V28.6172C106.977 20.5789 114.031 14.2151 121.293 9.51953C128.256 5.01702 135.371 2.07444 140.022 0.668945V105.468C138.037 125.062 127.079 137.051 114.157 144.099C101.21 151.159 86.3019 153.248 76.5342 153H76.5186C45.202 153.199 26.043 145.263 14.8027 135.338C3.55918 125.41 0.194252 113.456 0.521484 105.521V0.582031Z" />
          </clipPath>
        </defs>

        {/* Wavy water path */}
        <path
          d={buildWavePath()}
          fill={theme.lightTheme.themeCol}
          clipPath="url(#uClip)"
        />

        {/* Outline on top */}
        <path
          d="M0.521484 0.582031C8.77554 1.89949 16.6014 6.73563 23.082 12.3408C29.6416 18.0143 34.7745 24.433 37.5215 28.6494V96.5C37.5215 108.362 51.3492 124.524 76.5811 121.496C96.8835 119.06 102.679 103.869 103.021 96.5234L103.022 96.5117V28.6172C106.977 20.5789 114.031 14.2151 121.293 9.51953C128.256 5.01702 135.371 2.07444 140.022 0.668945V105.468C138.037 125.062 127.079 137.051 114.157 144.099C101.21 151.159 86.3019 153.248 76.5342 153H76.5186C45.202 153.199 26.043 145.263 14.8027 135.338C3.55918 125.41 0.194252 113.456 0.521484 105.521V0.582031Z"
          stroke="white"
          fill="none"
        />
      </svg>

      {loadingMessage && (
        <Typography sx={{ fontSize: 16, fontWeight: 600, color: "white" }}>
          {loadingMessage}
        </Typography>
      )}
    </Box>
  );
}

export default LoadingScreen;
